module.exports = __webpack_public_path__ + "static/media/corporateStep3.128ae32f.svg";